import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { money, MODE_META } from "@/lib/pricing";
import { Navbar } from "@/components/Navbar";
import { StatusBadge } from "@/components/StatusTracker";
import { Button } from "@/components/ui/button";
import { PackageSearch, ChevronRight } from "lucide-react";

export default function Tracker() {
  const { user, checked } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    if (checked && !user) { navigate("/login", { state: { next: "/track" } }); return; }
    if (user) api.get("/orders").then(({ data }) => setOrders(data)).catch(() => setOrders([]));
  }, [checked, user, navigate]);

  return (
    <div className="App min-h-screen bg-sugar-bg"><Navbar />
      <div className="mx-auto max-w-3xl px-6 py-10 lg:px-8">
        <h1 className="font-display text-3xl font-extrabold text-sugar-ink">Your orders</h1>
        <p className="mt-1 text-sugar-ink2">Track every cake from received to delivered.</p>

        {orders === null && <div className="py-16 text-center text-sugar-ink2">Loading…</div>}
        {orders && orders.length === 0 && (
          <div className="mt-10 rounded-2xl border border-dashed border-sugar-border bg-white p-12 text-center">
            <span className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-sugar-blush text-sugar-pink"><PackageSearch size={26} /></span>
            <h2 className="mt-4 font-display text-xl font-bold text-sugar-ink">No orders yet</h2>
            <p className="mt-1 text-sugar-ink2">Your cake orders will show up here.</p>
            <Button data-testid="tracker-order-btn" onClick={() => navigate("/order")} className="mt-5 rounded-full bg-sugar-pink px-7 py-5 font-bold text-white hover:bg-sugar-pinkhover">Start an order</Button>
          </div>
        )}

        <div className="mt-6 space-y-3">
          {orders?.map((o) => (
            <button key={o.id} data-testid={`track-order-${o.id}`} onClick={() => navigate(`/track/${o.id}`)} className="flex w-full items-center gap-4 rounded-2xl border border-sugar-border bg-white p-4 text-left sugar-lift">
              <img src={o.items[0]?.image} alt="" className="h-16 w-16 rounded-xl object-cover" />
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <span className="font-display text-lg font-bold text-sugar-ink">{o.items.map((i) => i.style_name).join(", ")}</span>
                </div>
                <p className="text-xs text-sugar-ink2">{MODE_META[o.mode]?.label} · {o.fulfillment_date} · {money(o.total)}</p>
                <div className="mt-1.5"><StatusBadge status={o.status} /></div>
              </div>
              <ChevronRight size={18} className="text-sugar-muted" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
